import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../Utility";

export const intialState = {
  loading: false,
  error: null,
  data: [],
  filterData: [],
  message: null,
  page: null,
  transactionReconciledDetail: null,
  transactionReconciledDetailError: null,
  addEditError: null,
  addEditSuccess: null,
  addEditLoading: false,
  redirectTo: null,
  transactionReconciledCategoryList: [],
};

const transactionReconciledListStart = (state, action) => {
  return updateObject(state, {
    loading: true,
    error: null,
    message: null,
    redirectTo: null,
  });
};

const transactionReconciledListFail = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: action.error,
    data: [],
    message: null,
    redirectTo: null,
  });
};

const transactionReconciledDetail = (state, action) => {
  return updateObject(state, {
    transactionReconciledDetail: action.data,
    transactionReconciledDetailError: action.error,
  });
};

const transactionReconciledListing = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: null,
    data: action.page === 1 ? action.data : [...state.data, ...action.data],
    filterData:
      action.page === 1 ? action.data : [...state.data, ...action.data],
    message: action.message,
    page: action.page,
    transactionReconciledDetailError: null,
    transactionReconciledDetail: null,
    redirectTo: null,
  });
};

const addEditSuccess = (state, action) => {
  return updateObject(state, {
    addEditSuccess: action.message,
    redirectTo: action.redirectTo,
    addEditLoading: false,
  });
};

const addEditFail = (state, action) => {
  return updateObject(state, {
    addEditError: action.error,
    addEditLoading: false,
  });
};

const addEditStart = (state, action) => {
  return updateObject(state, {
    addEditError: null,
    addEditSuccess: null,
    addEditLoading: true,
  });
};

const filterList = (state, action) => {
  let filterText = action.text;
  let fundData = state.filterData;
  let filteredItems = fundData.filter((item) => {
    if (
      item.title &&
      item.title.toLowerCase().includes(filterText.toLowerCase())
    ) {
      return true;
    }
    return false;
  });
  return updateObject(state, { data: filteredItems });
};

const reducer = (state = intialState, action) => {
  switch (action.type) {
    case actionTypes.TRANSACTION_LIST_START:
      return transactionReconciledListStart(state, action);
    case actionTypes.TRANSACTION_LIST_FAIL:
      return transactionReconciledListFail(state, action);
    case actionTypes.TRANSACTION_LIST_SUCCESS:
      return transactionReconciledListing(state, action);
    case actionTypes.TRANSACTION_DETAIL:
      return transactionReconciledDetail(state, action);
    case actionTypes.TRANSACTION_ADD_EDIT_SUCCESS:
      return addEditSuccess(state, action);
    case actionTypes.TRANSACTION_ADD_EDIT_FAIL:
      return addEditFail(state, action);
    case actionTypes.TRANSACTION_ADD_EDIT_START:
      return addEditStart(state, action);
    case actionTypes.TRANSACTION_LIST_FILTER:
      return filterList(state, action);
    default:
      return state;
  }
};

export default reducer;
